// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2862":"35278587","5524":"0d9fe6c4","6926":"0d9fe6c4"}[chunkId] + ".chunk.css";
};